import "./Tag.css";

export default function Tag({
  children,
  className,
  style,
}: {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <span style={style} className={`tag ${className ?? ""}`}>
      {children}
    </span>
  );
}
